import Vue from "vue";
import metadataService from "@/CommonDP/service/metadata-service.js";
const CACHE_FIELD = new Map();
// 作为事件bus,当字段数据加载完成时触发,使用次bus,可以直接方便获取字段列表
//  从'唯一名称组件'触发获取字段列表,可以直接分配到不同需要字段的组件中去
export const subFormBus = new Vue({
  data() {
    return {
      list: [],
      designer: {
        selectedId: null
      },
      parentWidget: {}
    };
  },
  computed: {
    curSubFormJY() {
      const { parentWidget } = this;
      return parentWidget || {};
    },
    isSubformJyht() {
      // 是否关联子表单
      return !!this.curSubFormJY.id;
    },
    subFormWidgetId() {
      return this.curSubFormJY.id;
    },
    subFormFieldNum() {
      return this.isSubformJyht ? this.curSubFormJY.options?.fieldNum || this.subFormWidgetId : "";
    }
  },
  watch: {
    "designer.selectedId": function (val) {
      if (/customsubform\d+/.test(val)) {
        // 这里的88888是默认值，需要重新赋值一个随机数
        if (this.designer?.selectedWidget.options.fieldNum === 88888) {
          this.designer.selectedWidget.options.fieldNum = Math.floor(Math.random() * 100000);
        }
      }
    }
  },
  methods: {
    bindDesigner(vm) {
      const { designer } = vm;
      if (this.designer === designer) return;
      this.designer = designer;
      this.onFieldSelected();
      designer.handleEvent("field-selected", this.onFieldSelected);
      vm.$on("hook:beforeDestroy", () => {
        this.designer = undefined;
        CACHE_FIELD.clear();
      });
    },
    onFieldSelected() {
      const {
        designer: {
          selectedId,
          vueInstance: { getContainerWidgets }
        }
      } = this;
      const clist = getContainerWidgets();
      let subFormWidget;
      for (const { container, type } of clist) {
        if (type === "custom-sub-form") {
          for (const widget of container.widgetList) {
            if (widget.id === selectedId) {
              subFormWidget = container;
              break;
            }
          }
        }
      }
      this.parentWidget = subFormWidget;
      if (subFormWidget) {
        const sublist = subFormWidget.options.sublist;
        this.getDicList(sublist);
      }
    },
    async getDicList(sublist) {
      subFormBus.list = [];
      if (!sublist) return;
      let data = [];
      if (CACHE_FIELD.has(sublist)) {
        data = CACHE_FIELD.get(sublist);
      } else {
        const res = await metadataService.columnList(sublist);
        data = res.data;
        CACHE_FIELD.set(sublist, data);
      }
      const randomNumb = this.subFormFieldNum;
      const subformList =
        data
          .filter((item) => item.isInternalField !== 1)
          .map((e) => {
            return {
              tableName: e.tableName,
              maxLength: ~~e.displayDataLength,
              rawLabel: e.columnDisplayName,
              label: `${e.columnDisplayName}(${e.columnName})`,
              name: `${sublist}_${randomNumb}-${e.columnName}`
            };
          }) || [];
      subFormBus.list = subformList;
    }
  }
});
